import React from 'react';

/**
 * Compute a tooltip label based on a label element `textContent` if the text overflows.
 * Updates dynamically on content changes (but not on resize!)
 */
export const useOverflowTooltipLabel = (content?: React.ReactNode) => {
    const [tooltipLabel, setTooltipLabel] = React.useState<string | undefined>(undefined);
    const [labelElement, setLabelElement] = React.useState<HTMLElement | null>(null);

    React.useLayoutEffect(() => {
        if (
            labelElement &&
            // Text overflows
            (!labelElement.offsetWidth || labelElement.offsetWidth < labelElement.scrollWidth)
        ) {
            // Set tooltip label
            setTooltipLabel(labelElement.textContent ?? undefined);
        } else {
            setTooltipLabel(undefined);
        }
    }, [labelElement, content]);

    return { labelRef: setLabelElement, tooltipLabel };
};
